import React from 'react'
import {Link, Typography} from '@mui/material'

function Copyright() {
  return (
    <div>
      <Typography
        variant='body2'
        color="text.secondary"
        align='center'>
          {'Copyright © '}
          <Link color="inherit" href="https://tecsir.com/">
            Tecsir
          </Link> {'  '}
          {new Date().getFullYear()}
          {'.'}
        </Typography>
    </div>
  )
}

export default Copyright